import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/Common/PageHeader";
import { all_routes } from "router/all_routes";

import useCashTransactions from "../hooks/useCashTransactions";
import CashboxTransactionsTable from "../table/CashboxTransactionsTable";
import DetailCashboxTransactionModal from "../modals/DetailCashboxTransactionModal";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import { FilterField } from "components/Common/TableFilter/TableFilter";
import AllCashboxTransactionsTable from "../table/AllCashboxTransactionsTable";

const CashboxTransactionsPage: React.FC = () => {
    const { t } = useTranslation();

    const {
        transactions,
        pagination,
        loading,
        fetchTransactions,
    } = useCashTransactions();

    const [isModalDetailOpen, setIsModalDetailOpen] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState<any | null>(null);
    const [filters, setFilters] = useState<{ [key: string]: any }>({});

    const handleViewDetails = (transaction: any) => {
        setSelectedTransaction(transaction);
        setIsModalDetailOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalDetailOpen(false);
        setSelectedTransaction(null);
    };

    useEffect(() => {
        fetchTransactions({ page: 1, limit: 10 });
    }, [fetchTransactions]);

    const breadcrumbItems = [
        { label: "finance_dashboard", path: all_routes.financeDashboard },
        { label: t("cashbox.transaction_history"), active: true },
    ];



    const filterFields: FilterField[] = [
        {
            key: "type",
            label: t("cashboxTransactions.fields.direction"),
            type: "select",
            options: [
                { label: t("cashboxTransactions.type.in"), value: "in" },
                { label: t("cashboxTransactions.type.out"), value: "out" },
            ],
        },
        { key: "date", label: t("cashboxTransactions.fields.date"), type: "range", rangeKeys: { start: "startDate", end: "endDate" } },
    ];

    const handleFilter = (newFilters: any) => {
        const params = {
            ...newFilters,
            page: 1,
            limit: 10,
        };

        setFilters(newFilters);
        fetchTransactions(params);
    };

    const handleTableChange = (pg: any) => {
        const params = {
            ...filters,
            page: pg.current || 1,
            limit: pg.pageSize || 10,
        };

        fetchTransactions(params);
    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader
                    title={t("cashbox.transaction_history")}
                    breadcrumbItems={breadcrumbItems}
                />



                <div className="d-flex mb-3 justify-content-end">
                    <TableFilterDynamique
                        fields={filterFields}
                        filters={filters}
                        onApply={handleFilter}
                        onReset={() => {
                            setFilters({});
                            fetchTransactions({ page: 1, limit: 10 });
                        }}
                    />
                </div>

                <AllCashboxTransactionsTable
                    data={transactions}
                    loading={loading}
                    handleViewDetails={handleViewDetails}
                    dataPaginate={{
                        current: pagination?.page || 1,
                        pageSize: pagination?.limit || 10,
                        total: pagination?.total,
                    }}
                    onChange={handleTableChange}
                />

                <DetailCashboxTransactionModal
                    isOpen={isModalDetailOpen}
                    onClose={handleCloseModal}
                    transaction={selectedTransaction}
                />
            </div>
        </div>
    );
};

export default CashboxTransactionsPage;